import React from 'react';
import { DemeterDataFrequency, DemeterTableDefinitionType } from '../../../../Generated/Raven-Demeter';
import { IRegionCommoditySelection } from '../../../Components/Navigation/Hooks/useRegionCommodityNavigationHook';
import useTableDefinition from '../../../Components/Navigation/Hooks/useTableDefinitionHook';
import useLanguage from '../../../Services/Language/useLanguageHook';
import { IPhysicalPricesChartProps } from '../../PhysicalPrices/PhysicalPricesChart';
import { IWithPageElementProps } from '../DashboardCustomizationDefinitions';

const withPhysicalPricesChartFromPageElement = (PhysicalPricesChart: React.ComponentType<IPhysicalPricesChartProps>): React.FC<IWithPageElementProps> => {
    const Wrapped: React.FC<IWithPageElementProps> = (props) => {
        if (!props.pageElement) {
            return <> </>;
        }

        const {
            demeterPageElementGuid,
            region,
            subRegion,
            commodity,
            commodityDisplayName,
            extraParameters,
            dataSource,
            subCommodity,
            subCommodityDisplayName,
            currency,
            unitOfMeasure,
            dataFrequency,
        } = props.pageElement;
        const [translations] = useLanguage();

        const [, tableDefinition] = useTableDefinition(DemeterTableDefinitionType.CommodityPricesTable, {
            region: region ?? '',
            commodity: commodity ?? '',
            subRegion: subRegion ?? '',
            dataFrequency: dataFrequency ?? '',
            extraParameters: extraParameters ?? '',
        });

        const pageTitle = translations.physicalPrices.title;

        const regionCommoditySelections = [
            {
                region: region ?? '',
                subRegion: subRegion ?? '',
                commodity: subCommodity ?? commodity ?? '',
                extraParameters: dataSource ?? extraParameters ?? '',
                dataFrequency,
                displayName: subCommodityDisplayName ?? commodityDisplayName ?? '',
                dataSource: dataSource ?? '',
            },
        ] as IRegionCommoditySelection[];

        const chartProps: IPhysicalPricesChartProps = {
            title: pageTitle,
            customTitle: props.customTitle,
            regionCommoditySelections,
            tableDefinitionType: DemeterTableDefinitionType.CommodityPricesTable,
            dataFrequency: dataFrequency ?? DemeterDataFrequency.Monthly,
            displayDecimalPlacesMinimum: tableDefinition?.displayDecimalPlacesMinimum ?? 2,
            displayDecimalPlacesMaximum: tableDefinition?.displayDecimalPlacesMaximum ?? 4,
            currency: currency === null ? undefined : currency,
            unitOfMeasure: unitOfMeasure === null ? undefined : unitOfMeasure,
            testId: `DashboardPhysicalPricesChart-${demeterPageElementGuid}`,
            dragIndicatorIcon: props.dragIndicatorIcon,
            isInDashboardEditMode: props.isInDashboardEditMode,
            maximizeMinimizeButton: props.maximizeMinimizeButton,
            maxWidthHeightRatio: props.maxWidthHeightRatio,
            handleMoreOptionsSelection: props.handleMoreOptionsSelection,
            track: props.track,
        };

        return <PhysicalPricesChart {...chartProps} />;
    };

    return Wrapped;
};

export default withPhysicalPricesChartFromPageElement;
